<script setup lang="ts">
/**
 * Centered icon + message for inline empty states within slideovers and panels.
 * Different from UEmpty which is for full-page empty states.
 */
withDefaults(
  defineProps<{
    icon: string
    message: string
    iconSize?: string
  }>(),
  { iconSize: "size-8" },
)
</script>

<template>
  <div class="text-muted flex flex-col items-center gap-2 py-8 text-center">
    <UIcon :name="icon" :class="[iconSize, 'opacity-30']" />
    <p class="text-sm">{{ message }}</p>
  </div>
</template>
